// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification {
  padding: 25px 15px;
  margin: 15px 0;
  font-weight: 800;
  text-align: center;
}
.notification.success {
  border: 1px solid #1c872f;
  color: #1c872f;
}
.notification.error {
  border: 1px solid #f00;
  color: #f00;
}`, "",{"version":3,"sources":["webpack://./application/shared/components/formNotification/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb","sourcesContent":[".notification {\n  padding: 25px 15px;\n  margin: 15px 0;\n  font-weight: 800;\n  text-align: center;\n}\n.notification.success {\n  border: 1px solid #1c872f;\n  color: #1c872f;\n}\n.notification.error {\n  border: 1px solid #f00;\n  color: #f00;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
